<template>
  <!-- 实时交易 -->
  <div>
    <!-- 头部-->
    <div class="city-child-head">
      <!-- 标题 -->
      <div class="city-child-head-left float-l">
        <div class="city-child-head-icon"></div>
        <span>实时交易</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="city-content city-content-chunk-box">
      <div class="city-box">
        <div class="titleBar d-flex">
          <div
            v-for="(item, index) in header"
            :key="index"
            :style="{ width: item.w, margin: 'auto' }"
          >
            <div>{{ item.title }}</div>
            <div v-if="item.sbuTitle">{{ item.sbuTitle }}</div>
          </div>
        </div>
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>
<script>
import { realTimeTradingStatistics } from '../../api/holdMy.js'
export default {
  data() {
    return {
      refreshImgIng: null, // 刷新定时器
      header: [
        { title: '公司', w: '60px' },
        { title: `交易运单`, sbuTitle: '(笔)', w: '47.5px' },
        { title: `已支付运`, sbuTitle: '单(笔)', w: '47.5px' },
        { title: `入网车辆`, sbuTitle: '(台)', w: '47.5px' },
        { title: `待入网车`, sbuTitle: '辆运次(笔)', w: '47.5px' },
      ],
      config: {
        header: [
          '公司',
          `交易运单(笔)`,
          `已支付运单(笔)`,
          `入网车辆(台)`,
          `待入网车辆运次`,
        ],
        data: [],
        rowNum: 23, //表格行数
        headerHeight: 27,
        headerBGC: 'rgba(0,144,255,0.2)', //表头
        oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
        evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
        align: ['left', 'center', 'center', 'center', 'center'],
        columnWidth: [60],
      },
      getData: {
        cityName: this.$route.query.cityName,
        city: this.$route.query.cityName,
      },
    }
  },
  components: {},
  created() {},
  mounted() {
    this.refreshScale()
  },

  beforeDestroy() {
    clearInterval(this.refreshImgIng)
  },
  methods: {
    // 刷新数据
    refreshScale() {
      this.getRealTimeTradingStatistics()
      this.refreshImgIng = setInterval(() => {
        this.getRealTimeTradingStatistics()
      }, 1000 * 60 * 30)
    },
    // 获取系统信息列表
    getRealTimeTradingStatistics() {
      let that = this
      realTimeTradingStatistics({ ...this.getData })
        .then((res) => {
          if (res.result == 0) {
            let userdata = res.userdata
            var data1 = []
            userdata.forEach((element) => {
              data1.push([
                `<span style="color:rgba(255, 255, 255, 0.4980392156862745);">${
                  element.company ? element.company : ''
                }</span>`,
                element.transactionWaybill ? element.transactionWaybill : 0,
                element.payTransactionWaybill
                  ? element.payTransactionWaybill
                  : 0,
                element.rwcl ? element.rwcl : 0,
                element.drwcl ? element.drwcl : 0,
              ])
            })
            that.config.data = data1
            that.config = { ...that.config } //关键,展开数组对象重新赋值.不写数据出不来
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/city.scss';

.city-content {
  height: 100%;

  .city-box {
    padding: 0px;
    overflow: hidden;
    width: 100%;
    height: calc(100% - 50px);

    .dv-scr-board {
      height: 100%;
    }

    .cj-1 {
      margin: 20px 20px;
    }

    .cj-box {
      background: inherit;
      background-color: rgba(26, 201, 255, 0.2980392156862745);
      height: 49px;
      font-size: 20px;
      line-height: 48px;
      padding-left: 10px;
      color: #1ac7fd;
    }

    .cj-box2 {
      width: 49%;
    }

    .cj-righ {
      margin-right: 10px;
    }

    .cj-2 {
      display: flex;
      align-content: center;
      width: 100%;
      margin-top: 15px;
    }
  }
}

::v-deep .dv-scr-board .header {
  display: none;
}
</style>
